__turbopack_context__.v({
  "bottomRow": "HDefault-module__EeDlDG__bottomRow",
  "brand": "HDefault-module__EeDlDG__brand",
  "brandLink": "HDefault-module__EeDlDG__brandLink",
  "controls": "HDefault-module__EeDlDG__controls",
  "inner": "HDefault-module__EeDlDG__inner",
  "logo": "HDefault-module__EeDlDG__logo",
  "root": "HDefault-module__EeDlDG__root",
  "topRow": "HDefault-module__EeDlDG__topRow",
  "windowsArea": "HDefault-module__EeDlDG__windowsArea",
  "windowsAreaColumn": "HDefault-module__EeDlDG__windowsAreaColumn",
});
